var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3334 13.0667C25.3334 18.3447 18.2171 24.7747 16.4123 26.3207C16.1733 26.5253 15.8269 26.5253 15.5878 26.3207C13.783 24.7747 6.66675 18.3447 6.66675 13.0667C6.66675 8.05928 10.8454 4 16.0001 4C21.1547 4 25.3334 8.05928 25.3334 13.0667Z",
    stroke: "#060606",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M15.9999 16C17.4727 16 18.6666 14.8061 18.6666 13.3333C18.6666 11.8605 17.4727 10.6666 15.9999 10.6666C14.5272 10.6666 13.3333 11.8605 13.3333 13.3333C13.3333 14.8061 14.5272 16 15.9999 16Z",
    stroke: "#060606",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d12710ae7161bc935c5aedefbc13bf83.svg";
export { ForwardRef as ReactComponent };